/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiShareLinkTypeFromJSON, ApiShareLinkTypeToJSON, } from './ApiShareLinkType';
export function ApiShareParametersFromJSON(json) {
    return ApiShareParametersFromJSONTyped(json, false);
}
export function ApiShareParametersFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'from': !exists(json, 'from') ? undefined : (new Date(json['from'])),
        'lastNDays': !exists(json, 'lastNDays') ? undefined : json['lastNDays'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'reportId': !exists(json, 'reportId') ? undefined : json['reportId'],
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'to': !exists(json, 'to') ? undefined : (new Date(json['to'])),
        'type': !exists(json, 'type') ? undefined : ApiShareLinkTypeFromJSON(json['type']),
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
    };
}
export function ApiShareParametersToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'clientId': value.clientId,
        'from': value.from === undefined ? undefined : (value.from.toISOString()),
        'lastNDays': value.lastNDays,
        'projectId': value.projectId,
        'reportId': value.reportId,
        'timezone': value.timezone,
        'to': value.to === undefined ? undefined : (value.to.toISOString()),
        'type': ApiShareLinkTypeToJSON(value.type),
        'userId': value.userId,
    };
}
